var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileAudio = function SvgIconFileAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 2A1.75 1.75 0 0 0 3.5 3.75v7.125a1 1 0 1 0 2 0V4h7.375v4.625a1 1 0 0 0 1 1H18.5V20h-1.625a1 1 0 1 0 0 2h1.875a1.75 1.75 0 0 0 1.75-1.75v-12a1 1 0 0 0-.293-.707l-5.25-5.25A1 1 0 0 0 14.25 2zm9.625 3.04v2.585h2.586z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.424 12.594A1 1 0 0 1 10 13.5V21a1 1 0 0 1-1.64.768l-1.972-1.643H4.5a1 1 0 0 1-1-1v-3.75a1 1 0 0 1 1-1h1.888l1.972-1.643a1 1 0 0 1 1.064-.138M8 15.635l-.61.508a1 1 0 0 1-.64.232H5.5v1.75h1.25a1 1 0 0 1 .64.232l.61.508z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.374 14.5a1 1 0 0 0-1.248 1.563 2 2 0 0 1 0 3.125 1 1 0 1 0 1.248 1.562 4 4 0 0 0 0-6.25"
  }))));
};
export default SvgIconFileAudio;